import React, { useEffect, useState, useRef } from 'react'
import VerifiedStats, { VerifiedStatsRef } from '../Csr/VerifiedStats'
import { ClientService } from '../../component/services/client.service'
import toast from 'react-hot-toast'
import Select from "react-select"
import moment from 'moment'
import { Button, Card, Col, Form, Row } from 'react-bootstrap'
import CsrStatsIndex, { CsrStatsIndexRef } from '../Csr/CsrStats.index'
import AvarageTimingStats from './AvarageTimingStats'
import VerificationTrends from './VerificationTrends'
import FiltersComponent, { FilterOption } from '../../component/Filters/FiltersComponent'
import StateStats, { IStateStatsRef } from './StateStats'
export default function Dashboard() {

    const [selectedValue, setSelectedValue] = useState<any>()
    const [shifts, setShifts] = useState<any>()
    const [districts, setDistricts] = useState<any>();
    const [states, setStates] = useState<any>();

    // Create ref for CsrStatsIndex
    const csrStatsRef = useRef<CsrStatsIndexRef>(null);
    const verificationDataRef = useRef<VerifiedStatsRef>(null);
    const stateStatsRef = useRef<IStateStatsRef>(null);

    const [selectedFilters, setSelectedFilters] = useState<{
        states: FilterOption[];
        zones: FilterOption[];
        districts: FilterOption[];
        centers: FilterOption[];
        courses?: FilterOption[];
    }>({
        states: [],
        zones: [],
        districts: [],
        centers: [],
        courses: []
    });

    const handleFiltersChange = (filters: any) => {
        setSelectedFilters(filters);
    };

    const getUniqueCity = async () => {
        if (!selectedValue) return;

        try {
            const params = new URLSearchParams();
            selectedFilters?.zones.forEach((zone) => params.append("zone[]", zone.value));
            selectedFilters?.states.forEach((state) => params.append("state[]", state.value));

            const res = await ClientService.getCities(selectedValue, "?" + params.toString());
            if (res.status === 200) {
                setDistricts(res.data?.districts?.map((zone: any) => ({
                    value: zone,
                    label: zone
                })));
            }
        } catch (err: any) {
            toast.error(err.response?.data || 'Failed to fetch cities');
        }
    };


    const getUniqueState = async () => {
        if (!selectedValue) return;

        try {
            const params = new URLSearchParams();

            const res = await ClientService.getStates(selectedValue, "?" + params.toString());
            if (res.status === 200) {
                setStates(res.data.states?.map((zone: any) => ({
                    value: zone,
                    label: zone
                })));
            }
        } catch (err: any) {
            toast.error(err.response?.data || 'Failed to fetch states');
        }
    };

    const getAllShift = async () => {
        await ClientService.getAllShifts().then(res => {
            if (res.status === 200) {
                setShifts(res.data.shifts.map((data: any) => {
                    return {
                        label: data.shiftName + " - " + moment(data.startTime).format("DD MMM YYYY"),
                        value: data._id,
                        startTime: data.startTime,
                        endTime: data.endTime,
                        biometricStartTime: data.biometricStartTime,
                        biometricEndTime: data.biometriEndTime
                    }
                }))
            }
        }).catch(err => {
            toast.error(err.response.data);
        })
    }

    useEffect(() => {
        getAllShift();
    }, [])

    useEffect(() => {
        if (selectedValue) {
            getUniqueCity();
            getUniqueState();
        }
    }, [selectedValue]);

    useEffect(() => {
        if (csrStatsRef.current) {
            csrStatsRef.current.getCountData();
        }
        // if (verificationDataRef.current) {
        //     verificationDataRef.current.getDataForGraphs();
        // }
        // if (stateStatsRef.current) {
        //     stateStatsRef.current.fetchData();
        // }
    }, [selectedFilters]);


    return (
        <>
            <Row className="mt-5 text-left">
                <Col md={8}>
                    <h4 className="text-secondary mt-3 fw-bold">Dashboard</h4>
                </Col>
                <Col md={4}>
                    <Form.Label className="text-muted fw-bold">
                        Select Shift
                    </Form.Label>
                    <Select
                        options={shifts}
                        // onChange={(e: any) => setSelectedShiftDate(e)} // Store full object
                        placeholder="Select Shifts"
                        onChange={(e: any) => setSelectedValue(e?.value)}
                        isClearable
                        value={selectedValue ? shifts.find((shift: any) => shift.value === selectedValue.value) : null}
                    />
                </Col>
            </Row>
            {!selectedValue ?
                <p className="text-secondary fw-bold text-center mt-3">Please select shift first...</p>
                :
                <>

                    <FiltersComponent
                        selectedShift={selectedValue}
                        onFiltersChange={handleFiltersChange}
                        showExamFilters={true}
                    />


                    <div className="mt-3 mb-3">
                        <CsrStatsIndex
                            ref={csrStatsRef}
                            shift={selectedValue}
                            selectedCenters={selectedFilters?.centers}
                            selectedZones={selectedFilters?.zones}
                            selectedDistrict={selectedFilters?.districts}
                            selectedStates={selectedFilters?.states}
                            states={states}
                            cities={districts}
                            selectedCourses={selectedFilters?.courses}
                        />
                    </div>

                    <div className="mt-3">
                        {/* <VerificationTrends
                            shiftId={selectedValue}
                            selectedStates={selectedStates}
                            selectedDistrict={selectedDistricts}
                            selectedZones={selectedZones}
                            selectedCenters={selectedCenters}
                            defaultEndTime={shifts?.find((shift: any) => shift.value === selectedValue)?.biometricEndTime}
                            defaultStartTime={shifts?.find((shift: any) => shift.value === selectedValue)?.biometricStartTime}
                            selectedCourses={selectedCourses}
                        /> */}
                        {/* <VerifiedStats
                            ref={verificationDataRef}
                            shiftId={selectedValue}
                            selectedCenters={selectedFilters?.centers}
                            selectedZones={selectedFilters?.zones}
                            selectedDistrict={selectedFilters?.districts}
                            selectedStates={selectedFilters?.states}
                            states={states}
                            cities={districts}
                            selectedCourses={selectedFilters?.courses}
                        />

                        <div>
                            <StateStats
                                ref={stateStatsRef}
                                shiftId={selectedValue}
                                cities={districts}
                            />
                        </div> */}
                    </div>
                </>
            }
        </>
    )
}
